import React from 'react';
import { UserCacheService } from '../services/user-cache.service';

interface RememberedUserProps {
  onContinue: (email: string) => void;
  onClear: () => void;
  className?: string;
}

export const RememberedUser: React.FC<RememberedUserProps> = ({
  onContinue,
  onClear,
  className = ''
}) => {
  const rememberedUser = UserCacheService.getRememberedUser();

  if (!rememberedUser) {
    return null;
  }

  const handleContinue = () => {
    onContinue(rememberedUser.email);
  };

  const handleClear = () => {
    UserCacheService.clearUser();
    onClear();
  };

  return (
    <div className={`bg-emerald-500/10 border border-emerald-400/30 rounded-lg p-4 backdrop-blur-sm ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            {rememberedUser.photoURL ? (
              <img
                src={rememberedUser.photoURL}
                alt="Avatar"
                className="w-10 h-10 rounded-full border border-emerald-400/30"
              />
            ) : (
              <div className="w-10 h-10 bg-emerald-500/20 border border-emerald-400/50 rounded-full flex items-center justify-center">
                <i className="ri-user-fill text-emerald-300 text-lg"></i>
              </div>
            )}
          </div>
          <div>
            <p className="text-sm font-medium text-emerald-200">
              Continuar con cuenta anterior
            </p>
            <p className="text-sm text-white font-semibold">
              {rememberedUser.displayName || rememberedUser.email}
            </p>
            {rememberedUser.displayName && (
              <p className="text-xs text-emerald-300">{rememberedUser.email}</p>
            )}
          </div>
        </div>
        <button
          type="button"
          onClick={handleClear}
          className="text-emerald-300 hover:text-emerald-100 transition-colors p-1 rounded hover:bg-emerald-500/20"
          title="Olvidar cuenta"
        >
          <i className="ri-close-line text-lg"></i>
        </button>
      </div>
      
      <div className="mt-3 flex space-x-2">
        <button
          type="button"
          onClick={handleContinue}
          className="flex-1 bg-gradient-to-r from-emerald-600 to-blue-600 hover:from-emerald-700 hover:to-blue-700 text-white py-2 px-4 rounded-md text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 focus:ring-offset-transparent"
        >
          <i className="ri-arrow-right-line mr-1"></i>
          Continuar
        </button>
        <button
          type="button"
          onClick={handleClear}
          className="px-4 py-2 text-emerald-300 text-sm font-medium hover:text-emerald-100 transition-colors hover:bg-emerald-500/10 rounded-md"
        >
          Otra cuenta
        </button>
      </div>
    </div>
  );
};